import { render } from "./SharedTableHeader.vue?vue&type=template&id=4b5280fc&scoped=true"
import script from "./SharedTableHeader.vue?vue&type=script&lang=js"
export * from "./SharedTableHeader.vue?vue&type=script&lang=js"

import "./SharedTableHeader.vue?vue&type=style&index=0&id=4b5280fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5280fc"]])

export default __exports__